<template>
  <div ref="vantaRef" class="vanta-dots-background" />
</template>

<script setup lang="ts">
const vantaRef = ref<HTMLElement | null>(null)
let vantaEffect: any = null

const { isDark } = useTheme()

const createEffect = () => {
  if (process.client && vantaRef.value) {
    // Destroy existing effect
    if (vantaEffect) {
      vantaEffect.destroy()
      vantaEffect = null
    }

    try {
      const THREE = window.THREE
      const VANTA = window.VANTA

      if (!THREE || !VANTA?.DOTS) {
        console.error('VantaDots: Three.js or Vanta.DOTS not loaded from CDN')
        return
      }

      vantaEffect = VANTA.DOTS({
        el: vantaRef.value,
        THREE: THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00,
        size: 4.00,
        spacing: 34.00,
        showLines: false,
        color: isDark.value ? 0xffbb3f : 0xff7800,
        backgroundColor: isDark.value ? 0x060518 : 0xffffff,
      })
    } catch (error) {
      console.error('VantaDots initialization failed:', error)
    }
  }
}

onMounted(() => {
  createEffect()
})

// Recreate effect when theme changes
watch(isDark, () => {
  if (process.client) {
    // Small delay to ensure DOM is ready
    nextTick(() => {
      createEffect()
    })
  }
})

onBeforeUnmount(() => {
  if (vantaEffect) {
    vantaEffect.destroy()
  }
})
</script>

<style scoped>
.vanta-dots-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  margin: 0;
  padding: 0;
  background-color: var(--bg-primary);
  transition: background-color 0.3s ease;
}

.vanta-dots-background :deep(canvas) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}
</style>
